import script from "./AdminEditCompany.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminEditCompany.vue?vue&type=script&setup=true&lang=js"

import "./AdminEditCompany.vue?vue&type=style&index=0&id=2d649768&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d649768"]])

export default __exports__